module.exports = __webpack_public_path__ + "static/img/bg_item_5.c948c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_5.png
// module id = xUy8
// module chunks = 1